module.exports = __webpack_public_path__ + "media/images/ANTIGEN-Mobile-2f2433971adbf1120bf4343472fd49aa.png";